<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.0435 13.0442H4.95676C3.66331 13.0442 2.61182 11.9918 2.61182 10.6992C2.61182 9.40668 3.66421 8.35429 4.95676 8.35429H19.0435C20.337 8.35429 21.3885 9.40668 21.3885 10.6992C21.3885 11.9918 20.3361 13.0442 19.0435 13.0442ZM4.95676 10.1533C4.65544 10.1533 4.41078 10.3979 4.41078 10.6992C4.41078 11.0006 4.65544 11.2452 4.95676 11.2452H19.0435C19.3449 11.2452 19.5895 11.0006 19.5895 10.6992C19.5895 10.3979 19.3449 10.1533 19.0435 10.1533H4.95676Z"
      fill="currentColor"
    />
    <path
      d="M16.1868 20.5H7.81442C7.00309 20.5 6.26821 20.0206 5.9417 19.2776L5.91562 19.2173L3.71908 11.2452H20.2812L18.0847 19.2173L18.0586 19.2776C17.7321 20.0206 16.9972 20.5 16.1859 20.5H16.1868ZM7.60844 18.5904C7.65342 18.6588 7.73077 18.701 7.81442 18.701H16.1868C16.2704 18.701 16.3478 18.6588 16.3928 18.5904L17.921 13.0442H6.08112L7.60934 18.5904H7.60844Z"
      fill="currentColor"
    />
    <path
      d="M18.905 10.1532H5.09618V7.30638C5.09618 5.75927 6.35546 4.5 7.90257 4.5H16.0977C17.6457 4.5 18.9041 5.75927 18.9041 7.30638V10.1532H18.905ZM6.89515 8.35428H17.1061V7.30638C17.1061 6.7505 16.6536 6.29896 16.0986 6.29896H7.90257C7.34669 6.29896 6.89515 6.7514 6.89515 7.30638V8.35428Z"
      fill="currentColor"
    />
    <path
      d="M9.94888 18.1406C9.45237 18.1406 9.0494 17.7377 9.0494 17.2411V14.3763C9.0494 13.8798 9.45237 13.4768 9.94888 13.4768C10.4454 13.4768 10.8484 13.8798 10.8484 14.3763V17.2411C10.8484 17.7377 10.4454 18.1406 9.94888 18.1406Z"
      fill="currentColor"
    />
    <path
      d="M14.2088 18.1406C13.7123 18.1406 13.3094 17.7377 13.3094 17.2411V14.3763C13.3094 13.8798 13.7123 13.4768 14.2088 13.4768C14.7053 13.4768 15.1083 13.8798 15.1083 14.3763V17.2411C15.1083 17.7377 14.7053 18.1406 14.2088 18.1406Z"
      fill="currentColor"
    />
  </svg>
</template>
